import { initErrorRegistry } from "@dzambalaorg/react-hooks-eth";
import { logger, createMezmoTransport } from "@dzambalaorg/logger";
import { errorSignatures } from "@framework/constants";

import { render } from "./utils/render";
import { App } from "./pages";
logger.configure({ context: { env: process.env.NODE_ENV }, transport: createMezmoTransport() });

logger.init({
  ingestKey: process.env.REACT_APP_LOGDNA_INGEST_KEY!,
  app: `cascadify-admin-ui-${process.env.NODE_ENV}`,
  sdk: {
    hostname: "cascadify-admin-ui",
    globalErrorHandlers: { enableErrorHandler: true, enableUnhandledPromiseRejection: true },
  },
});

initErrorRegistry(errorSignatures);

render(App);
